import { useHandlers } from '../../../context/page-context';
import type { SyncApiContract } from '../api';

export function useSyncApi(): { syncApi: SyncApiContract } {
  const { apis } = useHandlers();
  return { syncApi: apis.sync };
}
